import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { SliderComponent } from './home/slider/slider.component';
import { IntroductionComponent } from './home/introduction/introduction.component';
import { ServicesComponent } from './home/services/services.component';
import { SejamComponent } from './home/sejam/sejam.component';
import { NewSolutionsComponent } from './home/new-solutions/new-solutions.component';
import { NewInvestmentsComponent } from './home/new-investments/new-investments.component';
import { EdalatComponent } from './home/edalat/edalat.component';
import { BaseComponent } from './base/base.component';

import { NlComponent } from './nl/nl.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RoshAdvComponent } from './rosh-adv/rosh-adv.component';
import { RoshdComponent } from './roshd/roshd.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SliderComponent,
    IntroductionComponent,
    ServicesComponent,
    SejamComponent,
    NewSolutionsComponent,
    NewInvestmentsComponent,
    EdalatComponent,
    BaseComponent,
    SejamComponent,
    NlComponent,
    RoshdComponent,
    RoshAdvComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
